module.exports = __webpack_public_path__ + "static/media/44070682_1832037166926133_4255104579244392448_n.67fd57c8.jpg";